import { defaultConfig } from './config'

export function formatCurrency(value, currency = defaultConfig.currency) {
    const formats = {
        EUR: () => {
            return `${new Intl.NumberFormat('lt-LT', {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)} €`
        },
    }

    return formats[currency]?.() ?? `${value} ${currency}`
}

export function unbindOriginalSearch(selector) {
    const elements = document.querySelectorAll(selector);
    elements.forEach(el => {
        var newElement = el.cloneNode(true);
        el.parentNode.replaceChild(newElement, el);
    })
}

function detectWebsite() {
    if (location.hostname === 'www.dvf.com') {
        return 'usa'
    } else if (location.hostname === 'uk.dvf.com') {
        return 'uk'
    } else if (location.hostname === 'europe.dvf.com') {
        return "eu"
    } else if (location.hostname === 'hk.dvf.com') {
        return "hk"
    }
}

export const currency = {
    usa: '$',
    uk: '£',
    eu: "€",
    hk: "HK$",
}[detectWebsite()]

export function formatPrice(price) {
    const numericPrice = parseFloat(price);

    if (isNaN(numericPrice)) {
        return 'Invalid Price';
    }

    const formattedPrice = numericPrice.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');

    return formattedPrice;
}

export function formatPriceWithoutDecimal(price) {
    const numericPrice = parseFloat(price);

    if (isNaN(numericPrice)) {
        return 'Invalid Price';
    }

    const formattedPrice = numericPrice.toFixed(0).replace(/\d(?=(\d{3})+$)/g, '$&,');

    return formattedPrice;
}

export function createPlural(str) {
    if (str.toLowerCase().includes("type")) {
        return str = `${str.toLowerCase().replace("type", "Types")}`
    } else {
        return str = `${str}s `
    }
}

export function updateImageUrl(url, options = {}) {
    let updatedUrl;
    const { mobileSize = '600x', desktopSize = '600x' } = options
    const isMobile = window.innerWidth < 769;

    if (url) {
        const jpgSize = isMobile ? `_${mobileSize}.jpg` : `_${desktopSize}.jpg`
        const webpSize = isMobile ? `_${mobileSize}.webp` : `_${desktopSize}.webp`

        updatedUrl = url.replace('.jpg', jpgSize);
        updatedUrl = updatedUrl.replace('.webp', webpSize);
    }

    return updatedUrl;
}